import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGlobe = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	fill: "none",
	strokeWidth: 1.5,
	viewBox: "2 2 20 20",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 7.25,
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "inherit"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "inherit",
			d: "M15.25 12C15.25 16.5 13.2426 19.25 12 19.25C10.7574 19.25 8.75 16.5 8.75 12C8.75 7.5 10.7574 4.75 12 4.75C13.2426 4.75 15.25 7.5 15.25 12Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "inherit",
			d: "M5 12H12H19"
		})
	]
});
export default SvgGlobe;
